(function () {
  function ajustar(input, delta) {
    var min = input.min !== '' ? parseInt(input.min, 10) : 0;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var actual = parseInt(input.value, 10);
    if (isNaN(actual)) actual = min;
    var nuevo = actual + delta;
    if (nuevo < min) nuevo = min;
    if (nuevo > max) nuevo = max;
    if (nuevo === actual) return;
    input.value = nuevo;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('.cantidad-stepper__boton');
    if (!boton) return;
    var stepper = boton.closest('.cantidad-stepper');
    var input = stepper.querySelector('.cantidad-stepper__input');
    if (!input) return;
    ajustar(input, boton.dataset.accion === 'sumar' ? 1 : -1);
  });

  document.addEventListener('change', function (evento) {
    var input = evento.target.closest('.cantidad-stepper__input[data-auto-submit]');
    if (!input) return;
    var formulario = input.closest('form');
    if (formulario) formulario.requestSubmit ? formulario.requestSubmit() : formulario.submit();
  });
})();
